<template>
  <div id="SectionLackTransitionPlans">
    <UIContainer>
      <template #left>
        <SectionTitle>
          <template #title>
            <span class="SectionLackTransitionPlans__title">
              71% of companies with net zero commitments lack credible
              transition plans
            </span>
          </template>
          <template #description>
            <span class="SectionLackTransitionPlans__description">
              Making a net zero commitment is the easy part. The real challenge
              is turning that ambition into a science-backed, board-ready action
              plan. You face intense pressure from investors, customers, and
              regulators to prove your plan is credible and not just
              'greenwashing'.
            </span>
          </template>
        </SectionTitle>
        <div class="SectionLackTransitionPlans__cta">
          <UIButton size="xl" theme="primary" :to="{ name: 'Contact' }">
            Schedule a call
          </UIButton>
        </div>
      </template>

      <template #right>
        <img
          class="SectionLackTransitionPlans__image"
          src="../assets/lackTransitionPlans/transitionPlans.avif"
          alt="Manufacturing compliance challenges"
        />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
</script>

<style lang="scss" scoped>
#SectionLackTransitionPlans {
  background-color: $color-white;
  .SectionLackTransitionPlans__title {
    @include font-size-18px();
    @include md {
      @include font-size-30px;
    }
  }
  .SectionLackTransitionPlans__description {
    @include font-size-16px();
    color: $color-ui-gray-cool-600;
    @include md {
      @include font-size-18px;
    }
  }

  .SectionLackTransitionPlans__content {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    min-height: 420px;
    padding: 0 0 0 4.5rem;

    @include sm {
      margin-top: 3rem;
    }

    @include md {
      margin-top: 0rem;
      flex-direction: row;
      align-items: stretch;
      min-height: 520px;
    }
  }

  .SectionLackTransitionPlans__image {
    width: 100%;
    display: none;
    padding-left: 0rem;

    @include md {
      display: block;
      padding-left: 2rem;
    }
  }

  .SectionLackTransitionPlans__cta {
    display: flex;
    justify-content: flex-start;
    margin-top: 2rem;
  }
}
</style>
